var _rect, _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerOff(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 22,
    height: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M542.11,391.17a.49.49,0,0,1,0,.7,8.69,8.69,0,0,0-2.26,4.47l-.49-.09.49.09a8.61,8.61,0,0,0,3.88,8.76l-.25.4.25-.4a9,9,0,0,0,9.75,0,8.65,8.65,0,0,0,3.88-8.76h0a8.69,8.69,0,0,0-2.26-4.47.5.5,0,0,1,.72-.68,9.53,9.53,0,0,1,2.52,5l-.49.08.49-.08a9.51,9.51,0,0,1-.67,5.52A9.8,9.8,0,0,1,554,406a10.07,10.07,0,0,1-10.83,0l.27-.43-.27.43a9.8,9.8,0,0,1-3.65-4.26l.46-.2-.46.2a9.6,9.6,0,0,1-.68-5.52l.5.08-.5-.08a9.68,9.68,0,0,1,2.52-5A.5.5,0,0,1,542.11,391.17Z",
    transform: "translate(-537.62 -386.58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M548.62,387.62a.5.5,0,0,1,.5.5v11.09a.5.5,0,0,1-.5.5.51.51,0,0,1-.5-.5V388.12A.5.5,0,0,1,548.62,387.62Z",
    transform: "translate(-537.62 -386.58)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/powerOff.1be327962bcbf50da5131c0bb92b936b.svg";
export { ForwardRef as ReactComponent };